import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ButtonAndTooltipWrapper = styled.div`
    position: relative;
    width: auto;
    height: auto;

    @media (max-width: 1024px) {
      >div:nth-of-type(1){
        width: 200px;
      }
    }

    @media (max-width: 760px) {
      >div:nth-of-type(1){
        width: 130px;
      }
    }
`;

export const Tooltip = styled.div`
    position: absolute;
    width: 300px;
    max-width: calc(100vw - 32px);
    top: 110%;
    right: 0;
    background-color: #FFFFFF;
    border: 1px solid #E9ECF0;
    border-radius: 14px;
    box-shadow: 0px 12px 32px rgba(29, 33, 41, 0.16);
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    z-index: 10;
`;

export const TooltipOption = styled.button`
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 10px;
    border-radius: 10px;

    color: ${theme.colors.gray.Cinza_2};

    svg {
        flex-shrink: 0;
        margin-top: 2px;
        color: ${theme.colors.green.Verde_AgroReceita};
    }

    &:hover {
        background-color: #F4FBF7;
    }
`;

export const TooltipOptionText = styled.span`
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-align: left;
    cursor: pointer;

    b {
        font-size: 13px;
        font-weight: 800;
        color: ${theme.colors.gray.Cinza_2};
        cursor: pointer;
    }

    span {
        font-size: 11.5px;
        font-weight: 400;
        color: ${theme.colors.gray.Cinza_6};
        cursor: pointer;
    }
`;

export const AgronomosContainer = styled.section`
  background: #ffffff;
  height: 100%;
  padding: 50px 0 0 0;
  margin: auto;
  
  ul:first-child{
    margin-top: 15px;
  }

  ul:last-child{
    margin-bottom: 15px;
  }

  .search{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: -83px;
    margin-bottom: 20px;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: auto;
    
    .limpar{
      display: flex;
      justify-content: space-around;
      .botao{
        margin: 40px 30px 40px 1px;
        padding: 15px 50px;
      }
    .filterbuttons {
      width: 100%;
      max-width: 400px;
      .pesquisar {
        margin: 40px 0;
        padding: 20px 80px;
      }
    }
  }

  .botoesfinais{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    width: 50%;
    margin-top: 20px;
    .loadmore {
      margin: 30px 0;
      padding: 15px 20px;
    }
    .relatorio {
      display: flex;
      margin: 30px 0;
      padding: 15px 20px;
    }
  }

  }

  

  @media only screen and (max-width: 768px) {
    padding: 50px 0;
    background: #ffffff;
    height: 100%;
    
    ul:first-child{
      margin-top: 15px;
    }

    ul:last-child{
      margin-bottom: 15px;
    }
  

  
    .search{
      display: flex;
      flex-direction: row;
      width: 100%;
      max-width: 375px;
      margin-left: 0px;
      margin-top: -80px;
      
    }
    .add{
      width: 100%;
      max-width: 375px;
      margin-left: 0px;
      margin-top: -12px;
      align-self: center;
      button{
        width: 100%;
        align-self: center;
        max-width: 375px;
        margin-left: 0px;
        border-radius: 30px;
        border: solid 3px #FFF;
      }     
    }
  
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .loadmore {
        margin-top: -20px;
        width: 100%;
        max-width: 375px;
        margin-left: 0px;
        padding: 15px 20px;
      }
      .limpar{
        display: flex;
        justify-content: space-around;
        .botao{
          margin: 40px 30px 40px 1px;
          padding: 15px 50px;
        }
      .filterbuttons {
        width: 100%;
        max-width: 400px;
        .pesquisar {
          margin: 40px 0;
          padding: 20px 80px;
        }
      }
    }
  
    .relatorio {
      display: flex;
      width: 100%;
      justify-content: center;
      max-width: 375px;
      margin-left: 0px;
      padding: 15px;
    }
  
    .add {
      width: 100%;
      max-width: 375px;
      margin-left: 0px;
      align-self: center;
      button {
        align-self: center;
        width: 100%;
        max-width: 375px;
        margin-left: 0px;
        margin: 0px;
        padding: 20px 30px;
      }
    }
    }
  }

`;

export const AgronomosAddContainer = styled.div`
  padding: 50px 0;
  background: #ffffff;
  flex-direction:row;

    form {
      margin: auto;
      min-width: 250px;
      max-width: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .radios{
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 5px;
      label{
        width: 100%;
        padding-left: 5px;
        font-size: 11px;
        font-family: Lato;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        -webkit-letter-spacing: normal;
        -moz-letter-spacing: normal;
        -ms-letter-spacing: normal;
        letter-spacing: normal;
        color: #586377;
        display: flex;
        align-items: center;
        margin-bottom: 0px;
      }

      input[type='radio'] {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #2FBB69;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid white;
      }
      input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid white;
    }

      input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #2FBB69;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid white;
      }
    }

      .input-wrapper{
        width: 90%;
      }
      .arquivos{
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      label{
        font-size: smaller;
        width: 100%;
        margin-left: 5px;
        text-align: center;
        color: #8a92a2;
      }
      .btn-update{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 30px;
        border: dashed 1px #8a92a2;
        border-radius: 8px;
      }
      .arq-name{
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          transform: rotate(45deg);
          z-index: 10;
        }

        img:hover{
          cursor: pointer;
        }
      }
      }
      .legenda {
        font-size: smaller;
        width: 100%;
        margin-left: 5px;
      }
    }
  .salvar {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: -5%;
    .salvado {
      width: 30%;
    }
    .add {
      width: 60%;
    }
  }
  .addcrea{
    width: 100%;
    height: 50px;
    max-width: 400px;
    margin-bottom: 60px;
  }

  @media only screen and (max-width: 989px){
    .salvar {
      flex-direction: column-reverse;

      .salvado {
        width: 100%;
      }
      
      .add {
        width: 100%;
        height: 50px;
      }
    }

      .crea{
        width: 100%;
        justify-content: center;
        padding: 30px;
        padding: 0px;
        align-items: flex-end;
        .new{
          width: 82%;
          padding: 18px 80px;
          margin: auto;
          margin-top: 26px;
        }
      }
  }

  @media only screen and (max-width: 500px){
    .salvar {
      flex-direction: column-reverse;

      .salvado {
        width: 100%;
      }

      .add {
        width: 100%;
        height: 50px;
      }

    }

      .crea{
        width: 100%;
        justify-content: center;
        padding: 30px;
        padding: 0px;
        align-items: flex-end;
        .new{
          width: 86%;
          padding: 15px 80px;
          margin: auto;
          margin-top: 26px;

        }
      }
  }

  @media only screen and (max-width: 472px){
    .salvar {
      flex-direction: column-reverse;

      .salvado {
        width: 100%;
      }
      .add {
        width: 100%;
        height: 50px;
      }
    }

      .crea{
        width: 100%;
        justify-content: center;
        padding: 30px;
        padding: 0px;
        align-items: flex-end;
        .new{
          width: 90%;
          padding: 18px 80px;
          margin: auto;
          margin-top: 26px;

        }
      }
 
  }


  @media only screen and (max-width: 432px){
    .salvar {
      flex-direction: column-reverse;

      .salvado {
        width: 100%;
        }
      }

      .crea{
        width: 100%;
        justify-content: center;
        padding: 30px;
        padding: 0px;
        align-items: flex-end;
        .new{
          width: 100%;
          padding: 11px 80px;
          margin: auto;
          margin-top: 26px;

        }
      }
  }

`;
export const AgronomosnewContainer = styled.div`
padding: 50px 100px ;
background: #ffffff;
div {
  display: flex;
  justify-content: space-around;
  align-items:flex-start;
  left: 180%;
  min-height: 400px;
}
`;
export const Assinaturas = styled.p`
  text-align: center;
  width: 100%;
  max-width: 400px;
  font-size: 11px;
  margin-top: -24px;
  margin-bottom: 14px;
`;

export const ButtonPlans = styled.div`
     width: 100%;
     display: flex;
     margin-top: 1.25rem;
     margin-bottom: 0.938rem;
     flex-direction: row;
     justify-content: center; 
`;

export const Container = styled.div`
  >div>div{
    max-width: 480px;
    padding: 16px 32px 32px;

    >div:last-child {
      margin-bottom: 0;

      >div{
        margin-bottom: 0;

        >div>div:last-child {
          margin-bottom: 0;

          >div{
            width: 100%
          }
        }
      }
    }

    @media (max-width: 843px) {
      max-width: 100%;
    }
  }
`;

export const ContainerContent = styled.div`
  width: 100%;
  height: auto;
  max-width: 28.75rem;

  >img{
      @media (max-width: 480px) {
            width: 8rem;
      }
    }

  >h5{
      margin-top: 1rem;

      @media (max-width: 480px) {
          font-size: 1.4rem;
      }
  }

  >p{
     margin-top: 1rem;

      >span{
        @media (max-width: 480px) {
          font-size: 1rem;
        }
      }

     @media (max-width: 480px) {
          font-size: 1rem;
      }
  }

  >p:nth-of-type(2){
      margin-top: 0.5rem;

      @media (max-width: 480px) {
            font-size: 0.9rem;
            line-height: 1rem;
      }
  }

    >div >div {
        >div:nth-of-type(1) {}

        >div:nth-of-type(2) {
          margin-bottom: 0;      
        }
    }
`;

export const ModalBody = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  text-align: ${props => props.textAlign ? props.textAlign : 'center'};
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : '32px'} ;
`;

export const ContainerPage = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  align-items: center;
  flex-direction: column;

  background-color: ${theme.colors.white.Branco};
`

export const ContainerBody = styled.div`
  width: 100%;
  height: auto;
  padding: 24px;
  max-width: 1105px;

  gap: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 790px) {
      padding: 16px;
  }

  @media (max-width: 479px) {
      gap: 16px;
  }
`

export const ContainerInputAndButton = styled.div`
  width: 100%;
  height: auto;

  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  @media (max-width: 1365px) {
    align-items: center;
    flex-direction: column;
  }

  /* @media (max-width: 790px) {
    align-items: center;
    flex-direction: column;
  } */
`

export const ContainerFiltersAndButtons = styled.div`
  width: 100%;
  height: auto;

  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  @media (max-width: 1365px) {
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    gap: 6px;

    >div:nth-of-type(4){
      width: 100px;
    }
  }

  @media (max-width: 760px) {
    gap: 4px;

    >div:nth-of-type(2){
      width: auto;

      >div:nth-of-type(1) {
        padding: 12px 16px;

        >div{
          right: 0;
          position: relative;
        }
      }

      >div:nth-of-type(2) {
        padding: 8px;

        >div:nth-of-type(1) {
            padding: 8px 0;
        }
      }
    }

    >div:last-child{
      width: 100%;
    }
  }
`

export const ConatinerInputAndFilter = styled.div`
  width: auto;
  height: auto;

  gap: 8px;
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
      width: 100%;
      justify-content: center;
  }

  @media (max-width: 760px) {
      width: 100%;

      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      >div:nth-of-type(1){
        min-width: auto;
      }

      >div:nth-of-type(2){
        min-width: auto;
      }
  }

  @media (max-width: 479px) {
      >div:nth-of-type(1){
        max-width: calc(100% - 148px);
      }

      >div:nth-of-type(4){
        width: calc(100% - 208px);
      }
  }

  @media (max-width: 340px) {
      >div:nth-of-type(4){
        width: 179px;
      }
  }
`

export const ContainerButtonView = styled.button`
  all: unset;

  width: auto;
  height: auto;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  >img{
    width: 35px;
    height: auto;
  }
`

export const ContainerInput = styled.div`
  width: 100%;
  height: auto;
  max-width: 330px;
  min-width: 330px;

  @media (max-width: 1024px) {
    max-width: 270px;
    min-width: auto;
  }

  // flex-basis pequeno (em vez do max-width de 270px valendo como tamanho
  // "preferido") - senão a busca sozinha já pesa o bastante pra estourar a
  // linha e cair sozinha abaixo do SwitchLayout (mesma armadilha resolvida
  // nas ARTs/TRT: a quebra de linha do flex-wrap usa o tamanho preferido de
  // cada item, não o mínimo). Com isso os dois sempre ficam juntos na
  // primeira linha, e o resto (UF, ordenação, ADICIONAR) quebra pra baixo.
  @media (max-width: 760px) {
    max-width: none;
    flex: 1 1 150px;
    min-width: 0;
  }

  @media (max-width: 365px) {
    max-width: 241px;
  }
`

export const ContainerLastUpdatesAndButton = styled.div`
    width: auto;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    >div>div{
      border-bottom-left-radius: 8px !important;
      border-bottom-right-radius: 8px !important;
    }

    @media (max-width: 1024px) {
        width: 100%;

        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
    }
`

export const Button = styled.button`
    all: unset;

    width: 100%;
    height: auto;
    max-width: 119px;
    padding: 1rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1.625rem;
    background-color: #2FBB69;

    position: relative;

    >img{
        height: auto;
        width: 1rem;
    }

    >p{
        cursor: pointer;
        
        text-align: center;
    }

    @media (max-width: 479px) {
      padding: 0.75rem 1rem;

      >img{
            height: auto;
            width: 1rem;
        }

        >p{
            cursor: pointer;
            
            text-align: center;
            font-size: 0.5rem;
        }
    }

    @media (max-width: 350px) {
      padding: 0.75rem 0;
    }
`
export const ButtonSecundary = styled.button`
    all: unset;

    width: auto;
    height: 14px;
    min-width: 70px;
    max-width: 165px;
    padding: 12px 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 1.625rem;

    position: relative;

    border: 1px solid ${theme.colors.gray.Cinza_2};
`

export const ContainerFooter = styled.div`
  width: 100%;
  height: auto;

  gap: 24px;
  display: flex;

  align-items: center;
  justify-content: center;

  >div:nth-of-type(1),
  >div:nth-of-type(2),
  >div:nth-of-type(3){
    width: 100%;
    max-width: 212px;
  }

  @media (max-width: 1320px) {
    flex-wrap: wrap;
    align-items: flex-start;

    >div:nth-of-type(1),
    >div:nth-of-type(2),
    >div:nth-of-type(3),
    >div:nth-of-type(4){
      width: 45%;
      max-width: 100%;
    }
  }

  @media (max-width: 479px) {
    gap: 16px;

    >div:nth-of-type(1),
    >div:nth-of-type(2),
    >div:nth-of-type(3),
    >div:nth-of-type(4){
      width: 100%;
      max-width: 100%;
    }
  }
`

export const ButtonShowAll = styled.button`
  all: unset;
  height: auto;
  width: 6.6875rem;

  gap: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  
  cursor: pointer;
  
  >p{
      cursor: pointer;
      text-align: center;
  }

  >img{
      width: 1rem;
      height: auto;
  }
`;

export const ContainerItemNotFound = styled.div`
  width: 100%;
  height: auto;
  padding: 5rem 0;

  gap: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  >img{
    width: 100%;
    height: auto;
    max-width: 150px;
  }
`;

export const ContainerLoading = styled.div`
  width: 100%;
  height: auto;
  padding: 4rem 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: ${props => props.width ? props.width : '20px'};
  height: ${props => props.height ? props.height : '20px'};
  position: relative;

  background-color: transparent;
  border-top: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-bottom: 1px solid ${props => props.color ? props.color : theme.colors.gray.Cinza_2};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;
